// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"530a4498","239":"eeff4e4f","453":"fe5d92fe","667":"78ab1d1f"}[chunkId] + ".chunk.js";
};